//@ts-check
import {Button, TextInput} from '@/components/atoms'
import {useComboSubCategories} from '@/hooks/productCombo/useComboSubCategories'
import {Font} from 'pepsico-ds'

export const ComboSubCategories = () => {
  const {
    languages,
    subCategories,
    isAddSubCategoryDisabled,
    handleAddSubCategory,
    handleRemoveSubCategory,
    handleSubCategoryCodeChange,
    handleSubCategoryNameChange,
  } = useComboSubCategories()

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <Button
          uiSchema={{
            variant: 'tertiary',
            title: 'Add Subcategory',
            size: 'medium',
            isDark: true,
            iconLeading: 'add_box',
            disabled: isAddSubCategoryDisabled,
            className: isAddSubCategoryDisabled ? 'opacity-25' : '',
          }}
          handleButton={handleAddSubCategory}
        />
      </div>
      {subCategories.map((subCategory, index) => (
        <div key={`combo-subcategory-${index}`} className="flex flex-col gap-4 border-t border-gray-600 pt-4">
          <div className="flex items-end justify-between gap-4">
            <TextInput
              id={`combo-subcategory-id-${index}`}
              label="Subcategory ID"
              placeholderText="Enter subcategory ID"
              value={subCategory.code}
              onChange={value => handleSubCategoryCodeChange(index, value)}
              required
              maxLength={255}
            />
            <Button
              uiSchema={{variant: 'tertiary', title: 'Delete Subcategory', size: 'medium', isDark: true}}
              handleButton={() => handleRemoveSubCategory(index)}
            />
          </div>
          <div className="grid grid-cols-3 gap-4">
            {languages.map(language => (
              <div key={`${index}-${language.code}`} className="flex flex-col gap-2">
                <Font variant="medium">{language.language}</Font>
                <TextInput
                  id={`combo-subcategory-${index}-${language.code}`}
                  label="Subcategory Name"
                  placeholderText="Enter subcategory name"
                  value={subCategory.values?.[language.code] || ''}
                  onChange={value => handleSubCategoryNameChange(index, language.code, value)}
                  required
                  maxLength={255}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
